import { Button } from '@cibli/shared';
import { Loader2, Undo2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type CancelProcessingButtonProps = {
  isLoading: boolean;
  onCancel: () => void;
};

export default function CancelProcessingButton({
  isLoading,
  onCancel,
}: CancelProcessingButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      className="mt-4"
      size="lg"
      variant="destructive"
      onClick={onCancel}
      disabled={isLoading}
    >
      {isLoading ? <Loader2 className="size-4 animate-spin" /> : <Undo2 className="size-4" />}
      {t('common.cancel')}
    </Button>
  );
}
